import React from 'react';

export const TermsCondition = () => {
  return (
    <div className='max-w-4xl mx-auto min-h-[60vh] py-4 text-indigo px-8'>
      <h3 className='text-center font-semibold text-2xl py-4'>
        AWAP INVESTORS LTD &ndash; Terms and Conditions
      </h3>

      <p className='font-light mb-4 text-center'>
        <strong>Effective Date:</strong> 1st May, 2024
      </p>

      {/* 1 */}
      <h4 className='font-medium py-4'>1. General Terms</h4>
      <p className='font-light mb-4'>
        1.1. These Terms and Conditions (&ldquo;Terms&rdquo;) govern the use of
        the AWAP INVESTORS LTD platform and all services provided through it.
      </p>
      <p className='font-light mb-4'>
        1.2. By creating an account or using any of our services, you agree to
        be bound by these Terms.
      </p>
      <p className='font-light mb-4'>
        1.3. AWAP INVESTORS LTD reserves the right to modify these Terms at any
        time. Updated versions shall become effective upon publication on the
        Platform.
      </p>
      <p className='font-light mb-4'>
        1.4. AWAP INVESTORS LTD is a company registered in Nigeria and operates
        in accordance with applicable laws.
      </p>
      <p className='font-light mb-4'>
        1.5. These Terms constitute a legally binding agreement between you and
        AWAP INVESTORS LTD.
      </p>

      {/* 2 */}
      <h4 className='font-medium py-4'>2. Definitions</h4>
      <p className='font-light mb-4'>
        2.1. <strong>Platform</strong> means the AWAP INVESTORS LTD website,
        mobile application and related services.
      </p>
      <p className='font-light mb-4'>
        2.2. <strong>User</strong> means any registered or unregistered person
        using the Platform.
      </p>
      <p className='font-light mb-4'>
        2.3. <strong>Account</strong> means a registered user profile.
      </p>
      <p className='font-light mb-4'>
        2.4. <strong>Project Slots (APS)</strong> means project participation
        opportunities with specified duration and projected returns.
      </p>
      <p className='font-light mb-4'>
        2.5. <strong>AWAP Project Units (APU)</strong> means digital project
        units whose value is evaluated based on the performance of Project Slots
        and may appreciate according to company policy.
      </p>
      <p className='font-light mb-4'>
        2.6. <strong>Real Estate Market</strong> means the Platform where users
        can buy and sell eligible landed properties.
      </p>
      <p className='font-light mb-4'>
        2.7. <strong>Land Pay</strong> means the company&apos;s weekly
        installment land purchase plan for up to one (1) year.
      </p>
      <p className='font-light mb-4'>
        2.8. <strong>Main Wallet</strong> means the user&apos;s primary wallet
        for deposits, withdrawals, project participation, savings, loan
        repayment and other eligible transactions.
      </p>
      <p className='font-light mb-4'>
        2.9. <strong>Reserved Capital Wallet</strong> means the internal wallet
        used primarily for purchasing AWAP Project Units (APU) and other
        eligible ecosystem transactions.
      </p>
      <p className='font-light mb-4'>
        2.10. <strong>Savings</strong> means the Fixed Savings Plan and Regular
        Savings Plan.
      </p>
      <p className='font-light mb-4'>
        2.11. <strong>Loan</strong> means any approved credit facility granted
        by the company.
      </p>
      <p className='font-light mb-4'>
        2.12. <strong>Builders Reward System (BRS)</strong> means the
        company&apos;s optional referral and leadership rewards program.
      </p>
      <p className='font-light mb-4'>
        2.13. <strong>Crypto Trading</strong> means the buying and selling of
        supported cryptocurrencies through company rates.
      </p>

      {/* 3 */}
      <h4 className='font-medium py-4'>3. Account Registration</h4>
      <p className='font-light mb-4'>
        3.1. Users must register before accessing member services.
      </p>
      <p className='font-light mb-4'>
        3.2. All registration information must be accurate and match the
        user&apos;s KYC documents.
      </p>
      <p className='font-light mb-4'>
        3.3. Users are responsible for protecting their login credentials.
      </p>
      <p className='font-light mb-4'>
        3.4. AWAP INVESTORS LTD may suspend or terminate accounts containing
        false or misleading information.
      </p>

      {/* 4 */}
      <h4 className='font-medium py-4'>4. Project Slots (APS)</h4>
      <p className='font-light mb-4'>
        4.1. Project Slots represent participation in specific company projects
        with stated duration and projected returns.
      </p>
      <p className='font-light mb-4'>
        4.2. Project Slot investments cannot be cancelled once confirmed.
      </p>
      <p className='font-light mb-4'>
        4.3. Project proceeds become redeemable upon project maturity through
        the Redeem function.
      </p>
      <p className='font-light mb-4'>
        4.4. Project returns remain subject to project performance and company
        policy.
      </p>
      <p className='font-light mb-4'>
        4.5. Users should carefully review every project before participating.
      </p>

      {/* 5 */}
      <h4 className='font-medium py-4'>5. AWAP Project Units (APU)</h4>
      <p className='font-light mb-4'>
        5.1. AWAP Project Units represent digital participation in the
        company&apos;s ecosystem.
      </p>
      <p className='font-light mb-4'>
        5.2. Unit values may appreciate or depreciate based on company
        performance and market activities.
      </p>
      <p className='font-light mb-4'>
        5.3. Newly purchased units may be subject to the company&apos;s holding
        period before becoming tradable.
      </p>
      <p className='font-light mb-4'>
        5.4. Users may trade APU through the Project Unit Market, transfer units
        to eligible users or participate in company buyback programs where
        available.
      </p>
      <p className='font-light mb-4'>
        5.5. Market prices are determined by the prevailing unit value and
        platform activities.
      </p>

      {/* 6 */}
      <h4 className='font-medium py-4'>6. Real Estate Market &amp; Land Pay</h4>
      <p className='font-light mb-4'>
        6.1. Users may purchase eligible landed properties through the Real
        Estate Market.
      </p>
      <p className='font-light mb-4'>
        6.2. Land Pay enables qualified users to acquire land through weekly
        installment payments for up to one (1) year.
      </p>
      <p className='font-light mb-4'>
        6.3. Ownership documents shall be processed after all payment
        obligations have been fulfilled.
      </p>
      <p className='font-light mb-4'>
        6.4. Failure to complete installment obligations may result in penalties
        or cancellation in accordance with company policy.
      </p>

      {/* 7 */}
      <h4 className='font-medium py-4'>7. Loans</h4>
      <p className='font-light mb-4'>
        7.1. Loan approval depends on user eligibility and company assessment.
      </p>
      <p className='font-light mb-4'>
        7.2. Loan interest ranges between 5% and 10% per month depending on the
        approved facility.
      </p>
      <p className='font-light mb-4'>
        7.3. Monthly repayments may be automatically deducted from the
        user&apos;s Main Wallet.
      </p>
      <p className='font-light mb-4'>
        7.4. Users may also make manual repayments or repay multiple months in
        advance.
      </p>
      <p className='font-light mb-4'>
        7.5. Default or late repayment may attract penalties or affect future
        loan eligibility.
      </p>

      {/* 8 */}
      <h4 className='font-medium py-4'>8. Savings</h4>
      <p className='font-light mb-4'>
        8.1. The Platform offers Fixed Savings and Regular Savings Plans.
      </p>
      <p className='font-light mb-4'>
        8.2. Fixed Savings currently earns 3% monthly interest.
      </p>
      <p className='font-light mb-4'>
        8.3. Regular Savings uses automatic weekly deductions and does not
        attract interest.
      </p>
      <p className='font-light mb-4'>
        8.4. Savings become withdrawable upon maturity or completion of the
        selected target or duration.
      </p>
      <p className='font-light mb-4'>
        8.5. Early withdrawal conditions shall be governed by the applicable
        savings plan.
      </p>

      {/* 9 */}
      <h4 className='font-medium py-4'>9. Wallet Services</h4>
      <p className='font-light mb-4'>
        9.1. The Main Wallet may be used for Project Slots, Real Estate
        purchases, Savings, Loan repayments, withdrawals and other approved
        services.
      </p>
      <p className='font-light mb-4'>
        9.2. Reserved Capital may be used to purchase AWAP Project Units (APU)
        and for approved ecosystem transactions.
      </p>
      <p className='font-light mb-4'>
        9.3. Reserved Capital is not directly withdrawable.
      </p>
      <p className='font-light mb-4'>
        9.4. Users are responsible for funding the correct wallet before
        initiating transactions.
      </p>

      {/* 10 */}
      <h4 className='font-medium py-4'>10. Builders Reward System (BRS)</h4>
      <p className='font-light mb-4'>
        10.1. Participation in the Builders Reward System is optional.
      </p>
      <p className='font-light mb-4'>
        10.2. Eligible users may receive Activation Bonuses, Builders Bonuses,
        Referral Bonuses, Team Bonuses and Rank Incentives in accordance with
        company policy.
      </p>
      <p className='font-light mb-4'>
        10.3. AWAP INVESTORS LTD reserves the right to review, amend or
        discontinue any reward structure where necessary.
      </p>

      {/* 11 */}
      <h4 className='font-medium py-4'>11. Crypto Trading</h4>
      <p className='font-light mb-4'>
        11.1. Users may buy and sell supported cryptocurrencies using company
        exchange rates.
      </p>
      <p className='font-light mb-4'>
        11.2. Crypto prices may change without prior notice.
      </p>
      <p className='font-light mb-4'>
        11.3. The company shall only process sell transactions after confirming
        receipt of the cryptocurrency.
      </p>
      <p className='font-light mb-4'>
        11.4. Users are responsible for sending cryptocurrency to the correct
        wallet address and blockchain network.
      </p>
      <p className='font-light mb-4'>
        11.5. AWAP INVESTORS LTD shall not be liable for losses resulting from
        incorrect wallet addresses or network selection.
      </p>

      {/* 12 */}
      <h4 className='font-medium py-4'>12. Fees &amp; Payments</h4>
      <p className='font-light mb-4'>
        12.1. Certain services may attract service charges.
      </p>
      <p className='font-light mb-4'>
        12.2. Applicable fees shall be disclosed where necessary.
      </p>
      <p className='font-light mb-4'>
        12.3. Users are responsible for payment processing charges and
        applicable taxes.
      </p>
      <p className='font-light mb-4'>
        12.4. Payments made to incorrect wallet addresses remain the
        responsibility of the user.
      </p>

      {/* 13 */}
      <h4 className='font-medium py-4'>13. User Responsibilities</h4>
      <p className='font-light mb-4'>
        13.1. Users shall use the Platform lawfully and honestly.
      </p>
      <p className='font-light mb-4'>
        13.2. Fraud, money laundering, identity theft or illegal activities are
        strictly prohibited.
      </p>
      <p className='font-light mb-4'>
        13.3. Users must conduct their own research before participating in any
        investment, property or crypto transaction.
      </p>

      {/* 14 */}
      <h4 className='font-medium py-4'>14. Intellectual Property</h4>
      <p className='font-light mb-4'>
        14.1. All Platform content, trademarks, logos, software and materials
        remain the exclusive property of AWAP INVESTORS LTD.
      </p>
      <p className='font-light mb-4'>
        14.2. No content may be copied, reproduced or distributed without
        written permission.
      </p>

      {/* 15 */}
      <h4 className='font-medium py-4'>15. Privacy</h4>
      <p className='font-light mb-4'>
        15.1. User information shall be processed according to the
        company&apos;s Privacy Policy.
      </p>
      <p className='font-light mb-4'>
        15.2. Users consent to the collection and processing of personal
        information required for service delivery and regulatory compliance.
      </p>

      {/* 16 */}
      <h4 className='font-medium py-4'>16. Disclaimer &amp; Risk Disclosure</h4>
      <p className='font-light mb-4'>
        16.1. Investments, cryptocurrencies, project units and project slots
        involve risk.
      </p>
      <p className='font-light mb-4'>
        16.2. Past performance does not guarantee future results.
      </p>
      <p className='font-light mb-4'>
        16.3. AWAP INVESTORS LTD does not guarantee profits beyond officially
        published company policies.
      </p>
      <p className='font-light mb-4'>
        16.4. All investments, including Project Slots (APS), AWAP Project Units
        (APU), Real Estate transactions, Crypto Trading, Savings, Loans, and
        other financial services offered on the Platform involve varying levels
        of risk.
      </p>
      <p className='font-light mb-4'>
        16.5. The value of AWAP Project Units (APU), Project Slots,
        cryptocurrencies, and other investment products may increase or decrease
        due to market conditions, business performance, economic factors, or
        other unforeseen circumstances.
      </p>
      <p className='font-light mb-4'>
        16.6. Projected returns, appreciation rates, and estimated timelines are
        projections only and should not be interpreted as guaranteed future
        performance unless expressly stated by the company.
      </p>
      <p className='font-light mb-4'>
        16.7. Users are responsible for conducting their own research, assessing
        their financial objectives, and understanding the risks associated with
        any transaction before participating in any company service.
      </p>
      <p className='font-light mb-4'>
        16.8. AWAP INVESTORS LTD does not guarantee that every investment or
        transaction will generate profits, and users acknowledge that partial or
        total financial loss may occur in certain circumstances.
      </p>
      <p className='font-light mb-4'>
        16.9. By using the Platform, you confirm that you understand and
        voluntarily accept the risks associated with the company&apos;s products
        and services.
      </p>

      {/* 17 */}
      <h4 className='font-medium py-4'>17. Limitation of Liability</h4>
      <p className='font-light mb-4'>
        17.1. AWAP INVESTORS LTD shall not be liable for indirect, incidental or
        consequential losses arising from Platform usage.
      </p>
      <p className='font-light mb-4'>
        17.2. Company liability shall be limited to the extent permitted under
        applicable law.
      </p>

      {/* 18 */}
      <h4 className='font-medium py-4'>18. Termination</h4>
      <p className='font-light mb-4'>
        18.1. AWAP INVESTORS LTD may suspend or terminate any account that
        violates these Terms.
      </p>
      <p className='font-light mb-4'>
        18.2. Users may close their account by submitting a written request,
        subject to settlement of outstanding obligations.
      </p>

      {/* 19 */}
      <h4 className='font-medium py-4'>19. Governing Law</h4>
      <p className='font-light mb-4'>
        19.1. These Terms shall be governed by the laws of the Federal Republic
        of Nigeria.
      </p>
      <p className='font-light mb-4'>
        19.2. Any dispute shall first be resolved through negotiation before
        proceeding to arbitration or a court of competent jurisdiction in
        Nigeria.
      </p>

      {/* 20 */}
      <h4 className='font-medium py-4'>20. Amendments</h4>
      <p className='font-light mb-4'>
        20.1. AWAP INVESTORS LTD may amend these Terms from time to time.
      </p>
      <p className='font-light mb-4'>
        20.2. Updated Terms shall be published on the Platform and become
        effective immediately unless otherwise stated.
      </p>
      <p className='font-light mb-4'>
        20.3. Continued use of the Platform constitutes acceptance of the
        amended Terms.
      </p>
    </div>
  );
};
